import { api } from '../api-client.config';
import { TeamType } from 'src/types/domain.types';
import { useMutation } from '@tanstack/react-query';

const createTeam = (team: TeamType) => api.post(`/teams`, team);

export const useCreateTeamMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: any) => void;
}) => {
  return useMutation({
    mutationKey: ['createTeam'],
    mutationFn: createTeam,
    onSuccess,
    onError,
  });
};
